<template>
    <div id="main">
        <div class="cabecalho">
            <div class="pedido">
                <div class="listing-header my-2">
                    <div class="title-breadcrumb">
                        <h1 class="title">{{ title }}</h1>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="save-btn py-0 is-flex is-flex-centered"
                            v-if="hasPdfDownload"
                            type="button"
                            @click="downloadPdf"
                        >
                            <b-icon icon="file-export" class="mr-2" /> PDF
                        </button>
                    </div>
                </div>

                <!-- CABEÇALHO -->
                <div class="columns is-variable is-2 detalhes-pedido">
                    <!-- NOME, RSOCIAL, VENDEDOR, DATA CHECKIN -->
                    <div class="column is-one-third">
                        <div class="columns is-variable is-2 is-vcentered">
                            <div class="column detalhes-label">{{ $t('nome-do-cliente') }}</div>
                            <div class="column">
                                <v-input
                                    :value="pedido && pedido.cliente ? pedido.cliente.nome : ''"
                                    readonly
                                    smaller
                                    no-clearfix
                                />
                            </div>
                        </div>
                        <div class="columns is-variable is-2 is-vcentered">
                            <div class="column detalhes-label">{{ $t('razao-social') }}</div>
                            <div class="column">
                                <v-input
                                    :value="pedido && pedido.cliente ? pedido.cliente.rsocial : ''"
                                    readonly
                                    smaller
                                    no-clearfix
                                />
                            </div>
                        </div>
                        <div class="columns is-variable is-2 is-vcentered">
                            <div class="column detalhes-label">{{ $t('vendedor') }}</div>
                            <div class="column">
                                <v-input
                                    :value="pedido ? pedido.vendedor : ''"
                                    readonly
                                    smaller
                                    no-clearfix
                                />
                            </div>
                        </div>
                        <div
                            class="columns is-variable is-2 is-vcentered"
                            v-if="pedido.checks && pedido.checks.idcheck > 0"
                        >
                            <div
                                class="column detalhes-label"
                                :class="{
                                    'has-check-photo':
                                        pedido.checks.documentos &&
                                        pedido.checks.documentos.findIndex(
                                            (e) => e.datahora == pedido.checks.checkindatahora
                                        ) > -1,
                                }"
                                @click="openCheckPhotoModal('in')"
                            >
                                <b-icon
                                    v-if="
                                        pedido.checks.documentos &&
                                        pedido.checks.documentos.findIndex(
                                            (e) => e.datahora == pedido.checks.checkindatahora
                                        ) > -1
                                    "
                                    icon="camera"
                                    size="is-small"
                                />
                                <span>{{ $t('data-check-in') }}</span>
                            </div>
                            <div class="column">
                                <v-input
                                    :value="
                                        pedido.checks && pedido.checks.checkindatahora
                                            ? $moment(pedido.checks.checkindatahora).format('L LT')
                                            : ''
                                    "
                                    readonly
                                    smaller
                                    no-clearfix
                                />
                            </div>
                        </div>
                    </div>
                    <!-- TIPO PEDIDO, PRAZO, FORMA PGTO, DATA CHECKOUT -->
                    <div class="column is-one-third">
                        <div class="columns is-variable is-2 is-vcentered">
                            <div class="column detalhes-label">{{ $t('tipo-pedido') }}</div>
                            <div class="column">
                                <v-input
                                    :value="pedido ? pedido.tipopedido : ''"
                                    readonly
                                    smaller
                                    no-clearfix
                                />
                            </div>
                        </div>
                        <div class="columns is-variable is-2 is-vcentered">
                            <div class="column detalhes-label">{{ $t('prazo') }}</div>
                            <div class="column">
                                <v-input
                                    :value="pedido ? pedido.prazopagamento : ''"
                                    readonly
                                    smaller
                                    no-clearfix
                                />
                            </div>
                        </div>
                        <div class="columns is-variable is-2 is-vcentered">
                            <div class="column detalhes-label">{{ $t('forma-pgto') }}</div>
                            <div class="column">
                                <v-input
                                    :value="pedido ? pedido.forma - pagamento : ''"
                                    readonly
                                    smaller
                                    no-clearfix
                                />
                            </div>
                        </div>
                        <div
                            class="columns is-variable is-2 is-vcentered"
                            v-if="pedido.checks && pedido.checks.idcheck > 0"
                        >
                            <div
                                class="column detalhes-label"
                                :class="{
                                    'has-check-photo':
                                        pedido.checks.documentos &&
                                        pedido.checks.documentos.findIndex(
                                            (e) => e.datahora == pedido.checks.checkoutdatahora
                                        ) > -1,
                                }"
                                @click="openCheckPhotoModal('out')"
                            >
                                <b-icon
                                    v-if="
                                        pedido.checks.documentos &&
                                        pedido.checks.documentos.findIndex(
                                            (e) => e.datahora == pedido.checks.checkoutdatahora
                                        ) > -1
                                    "
                                    icon="camera"
                                    size="is-small"
                                />
                                <span>{{ $t('data-check-out') }}</span>
                            </div>
                            <div class="column">
                                <v-input
                                    :value="
                                        pedido.checks && pedido.checks.checkoutdatahora
                                            ? $moment(pedido.checks.checkoutdatahora).format('L LT')
                                            : ''
                                    "
                                    readonly
                                    smaller
                                    no-clearfix
                                />
                            </div>
                        </div>
                    </div>
                    <!-- DATA INCLUSÃO, DATA TRANSMISSÃO, DATA ERP, VERIFICOU QR -->
                    <div class="column is-one-third">
                        <div class="columns is-variable is-2 is-vcentered">
                            <div class="column detalhes-label">{{ $t('data-inclusao') }}</div>
                            <div class="column">
                                <v-input
                                    :value="
                                        pedido && pedido.datahora
                                            ? $moment(pedido.datahora).format('L LT')
                                            : ''
                                    "
                                    readonly
                                    smaller
                                    no-clearfix
                                />
                            </div>
                        </div>
                        <div class="columns is-variable is-2 is-vcentered">
                            <div class="column detalhes-label">{{ $t('data-transmissao') }}</div>
                            <div class="column">
                                <v-input
                                    :value="
                                        pedido && pedido.datahorainc
                                            ? $moment(pedido.datahorainc).format('L LT')
                                            : ''
                                    "
                                    readonly
                                    smaller
                                    no-clearfix
                                />
                            </div>
                        </div>
                        <div class="columns is-variable is-2 is-vcentered">
                            <div class="column detalhes-label">{{ $t('data-envio-erp') }}</div>
                            <div class="column">
                                <v-input
                                    :value="
                                        pedido && pedido.datahoraenvioerp
                                            ? $moment(pedido.datahoraenvioerp).format('L LT')
                                            : ''
                                    "
                                    readonly
                                    smaller
                                    no-clearfix
                                />
                            </div>
                        </div>
                        <div
                            class="columns is-variable is-2 is-vcentered"
                            v-if="pedido.checks && pedido.checks.idcheck > 0"
                        >
                            <div class="column detalhes-label">{{ $t('verificou-qr-code') }}</div>
                            <div class="column">
                                <v-input
                                    :value="
                                        pedido.checks && pedido.checks.verificouqrcode
                                            ? pedido.checks.verificouqrcode == 'S'
                                                ? $t('sim')
                                                : $t('nao')
                                            : $t('nao')
                                    "
                                    readonly
                                    smaller
                                    no-clearfix
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="listing-header">
                    <div class="title-breadcrumb"></div>
                    <div class="header-buttons">
                        <button
                            class="save-btn py-0 is-flex is-flex-centered"
                            v-if="assinatura.url_documento"
                            type="button"
                            @click="isImageAssinaturaModalActive = true"
                        >
                            {{ $t('pedido-assinatura') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="columns item-tabs">
            <div class="column is-full">
                <ul class="nav nav-tabs">
                    <li
                        :class="{ active: abaAtual == i }"
                        @click="changeTab(i)"
                        :key="i"
                        v-for="(aba, i) in abas"
                    >
                        <a data-toggle="tab" href="#">{{ $t(aba.label) }}</a>
                    </li>
                </ul>
            </div>
        </div>

        <!-- ABA DE ITENS DO PEDIDO -->
        <div class="columns tab-content" v-show="abas[abaAtual].label == 'itens'">
            <div class="column is-paddingless is-full content-wrapper" style="position: relative">
                <container-loader
                    v-if="isLoadingItens && !$store.getters.isLoading && !isLoading"
                    height="calc(100% - 50px)"
                />
                <b-table
                    class="data-table contagem"
                    :data="itensPedido"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in itemFields"
                        :key="i"
                        :field="f.key"
                        :class="{ 'label-km': f.key == 'status_pedido_retorno' }"
                        :label="f.label ? $t(f.label) : ''"
                        :width="f.width"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        :numeric="f.numeric"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'valorunitario' || f.key == 'valortotal'">
                            {{ getDecimal(props.row[f.key], null, true) }}
                        </div>

                        <div v-else-if="f.key == 'valortotalfat' || f.key == 'valorunfat'">
                            <div v-if="props.row.valorunitario != props.row.valorunfat">
                                <div class="roxo">
                                    <b>
                                        {{ getDecimal(props.row[f.key], null, true) }}
                                    </b>
                                </div>
                            </div>
                            <div v-else>
                                <b>
                                    {{ getDecimal(props.row[f.key], null, true) }}
                                </b>
                            </div>
                            <b> </b>
                        </div>

                        <div v-else-if="f.key == 'qtdefaturado'">
                            <div v-if="props.row.qtde != props.row.qtdefaturado">
                                <div class="roxo">
                                    <b>
                                        {{ getDecimal(props.row[f.key]) }}
                                    </b>
                                </div>
                            </div>
                            <div v-else>
                                <b>
                                    {{ getDecimal(props.row[f.key]) }}
                                </b>
                            </div>
                        </div>

                        <div v-else-if="f.key == 'qtde'">
                            {{ getDecimal(props.row[f.key]) }}
                        </div>

                        <div v-else-if="f.key == 'iditempedido'">
                            <div v-if="props.row[f.key] == '0'">
                                {{ props.row.idproduto }}
                            </div>
                            <div v-else>
                                {{ props.row.iditempedido }}
                            </div>
                        </div>

                        <div v-else-if="f.key == 'status_pedido_retorno'">
                            <div v-if="props.row[f.key] == 'ITEM_REMOVIDO'">
                                <div class="bar rem-ped" v-tippy :title="$t('item-removido')" />
                            </div>
                            <div v-else-if="props.row[f.key] == 'ITEM_ADICIONADO'">
                                <div class="bar add-ped" v-tippy :title="$t('item-adicionado')" />
                            </div>
                        </div>

                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <b-pagination
                    order="is-centered"
                    :total="totalRows"
                    :current.sync="currentPage"
                    :per-page="perPage"
                    @change="
                        origem == 'PEDIDORETORNO'
                            ? carregarItensPedidoRetorno(currentPage)
                            : carregarItensPedido(currentPage)
                    "
                />
                <div class="totalizadores">
                    <div class="totalizador-pedido">
                        {{ $t('valor-total-pedido') }}: 
                        {{ getDecimal(valorTotal, null, true) }}
                    </div>

                    <div class="totalizador-retorno" v-if="this.origem == 'PEDIDORETORNO'">
                        {{ $t('valor-total-faturado') }}: 
                        {{ getDecimal(valorTotalFat, null, true) }}
                    </div>
                </div>
            </div>
        </div>

        <!-- ABA DE CONTAGEM -->
        <div class="columns tab-content" v-show="abas[abaAtual].label == 'contagem'">
            <div class="column is-paddingless is-full content-wrapper" style="position: relative">
                <container-loader
                    v-if="contagem.loading && !$store.getters.isLoading && !isLoading"
                    height="100%"
                />
                <b-table
                    class="data-table itempedido"
                    :data="contagem.data"
                    @sort="sortContagem"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in contagem.fields"
                        :key="i"
                        :field="f.key"
                        :label="$t(f.label)"
                        :width="f.width"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        :numeric="f.numeric"
                        v-slot="props"
                    >
                        <div
                            v-if="
                                f.key == 'qtdeVendido' ||
                                f.key == 'sugestaovenda' ||
                                f.key == 'qtdeestoque' ||
                                f.key == 'qtdegondola' ||
                                f.key == 'qtdetroca'
                            "
                        >
                            {{
                                props.row[f.key] != undefined
                                    ? getDecimal(props.row[f.key])
                                    : '—'
                            }}
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                    <template slot="empty">
                        <empty-table
                            v-if="!contagem.loading"
                            height="calc(100vh - 375px)"
                            msg="msg-sem-contagem"
                        />
                    </template>
                </b-table>
                <b-pagination
                    order="is-centered"
                    :total="contagem.totalRows"
                    :current.sync="contagem.currentPage"
                    :per-page="contagem.perPage"
                    @change="carregarContagemItens"
                />
            </div>
        </div>

        <b-modal :active.sync="isCheckModalOpen">
            <div class="modal-card" v-if="pedido.checks">
                <header class="modal-card-head">
                    <p class="title is-marginless is-paddingless">{{ $t('fotos-check-in-out') }}</p>
                </header>
                <section class="modal-card-body">
                    <div class="columns">
                        <div
                            class="column is-half pic-wrapper"
                            v-for="(p, i) in pedido.checks.documentos"
                            :key="i"
                        >
                            <span>{{ $t(getLabel(p)) }}: {{ p.datahora | moment('L LT') }}</span>
                            <img :src="p.url_documento" @click="openPicture(p.url_documento)" />
                        </div>
                    </div>
                </section>
            </div>
        </b-modal>

        <b-modal :active.sync="isImageAssinaturaModalActive" width="25%">
            <div class="card">
                <div class="card-image">
                    <figure class="image">
                        <img :src="assinatura.url_documento" />
                    </figure>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import EmptyTable from '@/components/vendas/EmptyTable';
import PedidoService from '@/services/PedidoService';

export default {
    components: {
        EmptyTable,
        ContainerLoader,
    },
    props: {
        id: 0,
    },
    data() {
        return {
            abas: [
                { label: 'itens', loaded: true },
                { label: 'contagem', loaded: false },
            ],
            service: new PedidoService(this.$http, this.$router),
            abaAtual: 0,
            idPedido: null,
            idPedidoRetorno: null,
            isLoading: false,
            isLoadingItens: false,
            pedido: {},
            assinatura: {},
            isImageAssinaturaModalActive: false,
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            itemFields: [
                { key: 'status_pedido_retorno', width: 6, sortable: false, sortFn: null },
                {
                    key: 'idprodutoerp',
                    label: 'id-produto-erp',
                    width: 80,
                    sortable: true,
                    centered: true,
                },
                { key: 'produto', label: 'produto', width: null, sortable: true, centered: true },
                {
                    key: 'tipopedido',
                    label: 'tipo-pedido',
                    width: 180,
                    sortable: true,
                    centered: true,
                },
                {
                    key: 'qtde',
                    label: 'qntde',
                    width: 100,
                    sortable: true,
                    numeric: true,
                    centered: true,
                },
                {
                    key: 'qtdefaturado',
                    label: 'quantidade-faturada',
                    width: 110,
                    sortable: true,
                    numeric: true,
                    centered: true,
                },
                {
                    key: 'valorunitario',
                    label: 'valor-venda',
                    width: 120,
                    sortable: true,
                    numeric: true,
                    centered: true,
                },
                {
                    key: 'valorunfat',
                    label: 'valor-faturado',
                    width: 130,
                    sortable: true,
                    numeric: true,
                    centered: true,
                },
                {
                    key: 'valortotal',
                    label: 'valor-total',
                    width: 110,
                    sortable: true,
                    numeric: true,
                    centered: true,
                },
                {
                    key: 'valortotalfat',
                    label: 'valor-total-fat',
                    width: 120,
                    sortable: true,
                    numeric: true,
                    centered: true,
                },
            ],
            column: 'produto',
            order: 'asc',
            contagem: {
                loading: false,
                currentPage: 1,
                perPage: 20,
                totalRows: 0,
                column: 'produto',
                order: 'asc',
                fields: [
                    { key: 'produto', label: 'produto', sortable: true },
                    {
                        key: 'qtdegondola',
                        label: 'qtde-gondola',
                        width: 120,
                        sortable: true,
                        numeric: true,
                    },
                    {
                        key: 'qtdeestoque',
                        label: 'qtde-estoque',
                        width: 120,
                        sortable: true,
                        numeric: true,
                    },
                    {
                        key: 'qtdetroca',
                        label: 'qtde-troca',
                        width: 120,
                        sortable: true,
                        numeric: true,
                    },
                    {
                        key: 'sugestaovenda',
                        label: 'sugestao-venda',
                        width: 160,
                        sortable: true,
                        numeric: true,
                    },
                    {
                        key: 'qtdeVendido',
                        label: 'qtde-vendido',
                        width: 120,
                        sortable: true,
                        numeric: true,
                    },
                ],
                data: [],
            },
            isCheckModalOpen: false,
            itensPedido: [],
            valorTotal: undefined,
            valorTotalFat: undefined,
            hasPdfDownload: false,
            permissao: {},
        };
    },
    created() {
        this.origem = 'PEDIDO';

        this.permissao = this.hasPermissionAccess('vendas', 'vendas', 'ven-pedido');

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'pedidos' },
            });

        /**
         * Verifica qual o tipo do pedido para saber qual service irá consumir.
         */
        if (this.origem == 'PEDIDO') {
            this.carregarDados();
            this.carregarItensPedido(1);

            this.itemFields.splice(9, 1);
            this.itemFields.splice(7, 1);
            this.itemFields.splice(5, 1);
            this.itemFields.splice(0, 1);
        } else if (this.origem == 'PEDIDORETORNO') {
            /* No finally carrega os itens */
            this.carregarDadosPedidoRetorno();
        }
    },
    methods: {
        carregarDados() {
            this.$store.commit('addLoader');

            this.service
                .find(this.id)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(`[PEDIDO] Erro ${r.status} ao carregar pedido.`);
                        console.error(`[PEDIDO] Mensagem: [${r.message}]`);
                        this.$root.showMessage('error', 'pedido-erro');
                    } else {
                        this.pedido = r.content;
                        this.valorTotal = r.content.valortotal;
                        this.hasPdfDownload = this.isHttpUrlValid(this.pedido.urlPdf);
                    }
                })
                .then((r) => this.service.getSignature(this.id))
                .then((r) => {
                    if (r.status != 200) {
                        console.error(`[ASSINATURA] Erro ${r.status} ao carregar pedido.`);
                        console.error(`[ASSINATURA] Mensagem: [${r.message}]`);
                        this.$root.showMessage('error', 'pedido-assinatura-erro');
                    } else {
                        let assinaturas = r.content;
                        if (assinaturas && assinaturas.length) {
                            this.assinatura = assinaturas[0];
                        }
                    }
                })
                .catch((e) => {
                    console.error('[PEDIDO] Erro ao carregar pedido.', e);
                    this.$root.showMessage('error', 'pedido-erro');
                })
                .finally((_) => {
                    this.$store.commit('removeLoader');
                });
        },
        carregarDadosPedidoRetorno() {
            this.$store.commit('addLoader');

            this.service
                .findPedidoRetorno(this.id)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(`[PEDIDO] Erro ${r.status} ao carregar pedido.`);
                        console.error(`[PEDIDO] Mensagem: [${r.message}]`);
                        this.$root.showMessage('error', 'pedido-erro');
                    } else {
                        this.pedido = r.content;
                        this.valorTotalFat = r.content.valortotalfat;
                        this.valorTotal = r.content.valortotal;
                        this.hasPdfDownload = this.isHttpUrlValid(this.pedido.urlPdf);
                    }
                })
                .then((r) => this.service.getSignature(this.id))
                .then((r) => {
                    if (r.status != 200) {
                        console.error(`[ASSINATURA] Erro ${r.status} ao carregar pedido.`);
                        console.error(`[ASSINATURA] Mensagem: [${r.message}]`);
                        this.$root.showMessage('error', 'pedido-assinatura-erro');
                    } else {
                        let assinaturas = r.content;
                        if (assinaturas && assinaturas.length) {
                            this.assinatura = assinaturas[0];
                        }
                    }
                })
                .catch((e) => {
                    console.error('[PEDIDO] Erro ao carregar pedido.', e);
                    this.$root.showMessage('error', 'pedido-erro');
                })
                .finally((_) => {
                    this.$store.commit('removeLoader');
                    this.carregarItensPedidoRetorno(1);
                });
        },
        carregarItensPedido(page) {
            // console.log(`[PEDIDO] Carregando itens: [Página ${page} | Ordenação ${this.column},${this.order}]`);

            this.isLoadingItens = true;

            this.service
                .getItems(this.id, this.column, this.order, page > 0 ? page - 1 : 0, this.perPage)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(`[PEDIDO] Erro ${r.status} ao carregar itens do pedido.`);
                        console.error(`[PEDIDO] Mensagem: [${r.message}]`);
                        this.$root.showMessage('error', 'pedido-detalhes-erro');
                    } else {
                        this.totalRows = r.totalElements;

                        if (this.valorTotal === undefined) {
                            this.valorTotal = r.totalizador;
                        }

                        this.itensPedido = r.content;
                    }
                })
                .catch((e) => {
                    console.error('[PEDIDO] Erro ao carregar itens do pedido.', e);
                    this.$root.showMessage('error', 'pedido-detalhes-erro');
                })
                .finally((_) => {
                    this.isLoadingItens = false;
                });
        },
        carregarItensPedidoRetorno(page) {
            this.isLoadingItens = true;
            this.service
                .getItemsPedidoRetorno(
                    this.pedido.idpedido,
                    this.id,
                    this.column,
                    this.order,
                    page > 0 ? page - 1 : 0,
                    this.perPage
                )
                .then((r) => {
                    if (r.status != 200) {
                        console.error(`[PEDIDO] Erro ${r.status} ao carregar itens do pedido.`);
                        console.error(`[PEDIDO] Mensagem: [${r.message}]`);
                        this.$root.showMessage('error', 'pedido-detalhes-erro');
                    } else {
                        this.totalRows = r.totalElements;

                        if (this.valorTotal === undefined) {
                            this.valorTotal = r.totalizador;
                        }
                        this.itensPedido = r.content;
                    }
                })
                .catch((e) => {
                    console.error('[PEDIDO] Erro ao carregar itens do pedido.', e);
                    this.$root.showMessage('error', 'pedido-detalhes-erro');
                })
                .finally((_) => {
                    this.isLoadingItens = false;
                });
        },
        carregarContagemItens(page) {
            // console.log(`[PEDIDO] Carregando contagem: [Página ${page}|Ordenação ${this.contagem.column},${this.contagem.order}]`);

            this.contagem.loading = true;

            this.service
                .getContagem(
                    this.id,
                    this.contagem.column,
                    this.contagem.order,
                    page > 0 ? page - 1 : 0,
                    this.contagem.perPage
                )
                .then((r) => {
                    if (r.status != 200) {
                        console.error(`[PEDIDO] Erro ${r.status} ao carregar contagem do pedido.`);
                        console.error(`[PEDIDO] Mensagem: [${r.message}]`);
                        this.$root.showMessage('error', 'pedido-detalhes-erro');
                    } else {
                        this.contagem.totalRows = r.totalElements;
                        this.contagem.data = r.content;
                    }
                })
                .catch((e) => {
                    console.error('[PEDIDO] Erro ao carregar contagem do pedido.', e);
                    this.$root.showMessage('error', 'pedido-detalhes-erro');
                })
                .finally((_) => {
                    this.contagem.loading = false;
                });
        },
        changeTab(i) {
            this.abaAtual = i;

            if (!this.abas[i].loaded) {
                switch (this.abas[i].label) {
                    case 'contagem':
                        this.contagem.currentPage = 1;
                        this.carregarContagemItens(1);
                        this.abas[i].loaded = true;
                        break;
                    default:
                        console.error('[PEDIDO] Aba inválida.');
                        break;
                }
            }
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            if (this.origem == 'PEDIDO') {
                this.carregarItensPedido(this.currentPage);
            } else if (this.origem == 'PEDIDORETORNO') {
                this.carregarItensPedidoRetorno(this.currentPage);
            }
        },
        sortContagem(field, order) {
            this.contagem.column = field;
            this.contagem.order = order;
            this.carregarContagemItens(this.contagem.currentPage);
        },
        openCheckPhotoModal(type) {
            if (
                type == 'out' &&
                this.pedido.checks.documentos &&
                this.pedido.checks.documentos.findIndex(
                    (e) => e.datahora == this.pedido.checks.checkoutdatahora
                ) > -1
            ) {
                this.isCheckModalOpen = true;
            } else if (
                type == 'in' &&
                this.pedido.checks.documentos &&
                this.pedido.checks.documentos.findIndex(
                    (e) => e.datahora == this.pedido.checks.checkindatahora
                ) > -1
            ) {
                this.isCheckModalOpen = true;
            }
        },
        openPicture(url) {
            window.open(url, '_blank');
        },
        getLabel(d) {
            if (d.datahora == this.pedido.checks.checkindatahora) {
                return 'check-in';
            } else if (d.datahora == this.pedido.checks.checkoutdatahora) {
                return 'check-out';
            } else {
                return 'data';
            }
        },
        downloadPdf() {
            window.open(this.pedido.urlPdf, '_blank');
        },
    },
    computed: {
        title() {
            return this.pedido
                ? `${this.pedido.codigo} ${
                      this.pedido.cliente ? `- ${this.pedido.cliente.rsocial}` : ''
                  }`
                : '';
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;
    display: flex;
    flex-direction: column;

    .roxo {
        color: #e68b15;
    }

    .verde {
        color: rgb(16, 153, 16);
    }
    .label-km {
        padding-left: 0;
        padding-right: 0;
    }
    .bar {
        border-radius: 100px;
        width: 6px;
        height: 27px;
        position: absolute;
        top: -17px;

        &.add-ped {
            background-color: #5f971e;
        }

        &.rem-ped {
            background-color: #a82929;
        }
    }
    .bar-column {
        padding-left: 0.01rem;
        padding-right: 0.01rem;
    }
    @media (max-width: 760px) {
        .label-km {
            padding-left: 5px;
            padding-right: 20px;
            justify-content: left;
        }
    }

    .cabecalho {
        position: relative;

        .detalhes-pedido {
            padding-top: 1rem;
            color: $darker-gray-color;

            .detalhes-label {
                font-weight: 600;
            }

            .columns {
                & > .column {
                    padding-top: 0.25rem;
                    padding-bottom: 0.25rem;
                }

                &:last-child {
                    margin-bottom: -0.25rem;
                }
            }
        }

        .header-buttons {
            .save-btn {
                height: 43px;
            }
        }
    }

    .columns.tab-content {
        flex-grow: 1;
        margin-bottom: 5px;

        .content-wrapper {
            position: relative;
            display: flex;
            flex-direction: column;

            .itempedido,
            .contagem {
                flex-grow: 1;
            }
        }
    }

    .is-justify-end-sovis {
        justify-content: flex-end;
        display: flex;
    }

    .columns.item-tabs > .column > .nav.nav-tabs {
        margin-top: 0;
        margin-bottom: 0;
        margin-left: -20px;
        padding-left: 20px;

        li.active > a {
            color: $primary-color-click;
        }
    }

    .data-table {
        padding: 0 12px;
    }

    .pagination {
        padding-left: 12px;
    }

    .totalizadores {
        display: flex;
        justify-content: space-between;
        border-top: 1px solid $table-border;

        .totalizador-pedido {
            text-align: right;
            margin: 10px 14px;
            padding-top: 10px;
            color: $darker-gray-color;
            font-weight: 600;
        }

        .totalizador-retorno {
            text-align: left;
            margin: 10px 14px;
            padding-top: 10px;
            color: $darker-gray-color;
            font-weight: 600;
        }
    }

    .pic-wrapper {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        font-weight: 600;

        span {
            width: 100%;
            text-align: center;
        }

        img {
            cursor: pointer;
            max-height: 60vh;
        }
    }

    section.modal-card-body {
        border-bottom-right-radius: 6px;
        border-bottom-left-radius: 6px;
        color: $darker-gray-color;

        .columns {
            justify-content: center;
        }
    }
}

@media screen and (max-width: 769px), print {
    .page {
        .detalhes-pedido {
            .detalhes-label {
                padding-bottom: 0 !important;

                & + .column {
                    padding-top: 0 !important;
                }
            }
        }
    }
}
</style>
